import { render, staticRenderFns } from "./CalculatorSection.vue?vue&type=template&id=0d98e3a2&scoped=true"
import script from "./CalculatorSection.vue?vue&type=script&lang=js"
export * from "./CalculatorSection.vue?vue&type=script&lang=js"
import style0 from "./CalculatorSection.vue?vue&type=style&index=0&id=0d98e3a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d98e3a2",
  null
  
)

export default component.exports